/*
 * @file: éç¥å¬å
 * @author: linkun.he
 * @Date: 2018-11-12 19:49:04
 */
import { Component } from '@angular/core';
import * as _distanceInWordsToNow from 'date-fns/distance_in_words_to_now';

import { NzMessageService } from 'ng-zorro-antd';

import { NoticeIconList, NoticeItem } from './notify.model';

const distanceInWordsToNow = _distanceInWordsToNow;
/**
 * èåéç¥
 */
@Component({
  selector: 'dt-header-notify',
  templateUrl: './notify.component.html',
})
export class NotifyComponent {
  data: NoticeItem[] = [
    {
      title: 'éç¥',
      list: [],
      emptyText: 'ä½ å·²æ¥çææéç¥',
      emptyImage: 'https://gw.alipayobjects.com/zos/rmsportal/wAhyIChODzsoKIOBHcBk.svg',
      clearText: 'æ¸ç©ºéç¥',
    },
    {
      title: 'æ¶æ¯',
      list: [],
      emptyText: 'æ¨å·²è¯»å®æææ¶æ¯',
      emptyImage: 'https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg',
      clearText: 'æ¸ç©ºæ¶æ¯',
    },
    {
      title: 'å¾å',
      list: [],
      emptyText: 'ä½ å·²å®æææå¾å',
      emptyImage: 'https://gw.alipayobjects.com/zos/rmsportal/HsIsxMZiWKrNUavQUXqx.svg',
      clearText: 'æ¸ç©ºå¾å',
    },
  ];
  count = 5;
  loading = false;

  constructor(private msg: NzMessageService) {}

  updateNoticeData(notices: NoticeIconList[]): NoticeItem[] {
    const data = this.data.slice();
    data.forEach((i) => (i.list = []));

    notices.forEach((item) => {
      const newItem = { ...item };
      if (newItem.datetime) {
        newItem.datetime = distanceInWordsToNow(item.datetime, {
          locale: (window as any).__locale__,
        });
      }
      if (newItem.extra && newItem.status) {
        newItem.color = {
          todo: undefined,
          processing: 'blue',
          urgent: 'red',
          doing: 'gold',
        }[newItem.status];
      }
      data.find((w) => w.title === newItem.type).list.push(newItem);
    });
    return data;
  }

  loadData() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    setTimeout(() => {
      this.data = this.updateNoticeData([
        {
          id: '000000001',
          avatar: 'https://gw.alipayobjects.com/zos/rmsportal/ThXAXghbEsBCCSDihZxY.png',
          title: 'ä½ æ¶å°äº 14 ä»½æ°å¨æ¥',
          datetime: '2017-08-09',
          type: 'éç¥',
        },
        {
          id: '000000002',
          avatar: 'https://gw.alipayobjects.com/zos/rmsportal/OKJXDXrmkNshAMvwtvhu.png',
          title: 'ä½ æ¨èç æ²å¦®å¦® å·²éè¿ç¬¬ä¸è½®é¢è¯',
          datetime: '2017-08-08',
          type: 'éç¥',
        },
        {
          id: '000000003',
          avatar: 'https://gw.alipayobjects.com/zos/rmsportal/kISTdvpyTAhtGxpovNWd.png',
          title: 'è¿ç§æ¨¡æ¿å¯ä»¥åºåå¤ç§éç¥ç±»å',
          datetime: '2017-08-07',
          read: true,
          type: 'éç¥',
        },
        {
          id: '000000004',
          avatar: 'https://gw.alipayobjects.com/zos/rmsportal/GvqBnKhFgObvnSGkDsje.png',
          title: 'å·¦ä¾§å¾æ ç¨äºåºåä¸åçç±»å',
          datetime: '2017-08-07',
          type: 'éç¥',
        },
        {
          id: '000000005',
          avatar: 'https://gw.alipayobjects.com/zos/rmsportal/ThXAXghbEsBCCSDihZxY.png',
          title: 'åå®¹ä¸è¦è¶è¿ä¸¤è¡å­ï¼è¶åºæ¶èªå¨æªæ­',
          datetime: '2017-08-07',
          type: 'éç¥',
        },
        {
          id: '000000006',
          avatar: 'https://gw.alipayobjects.com/zos/rmsportal/fcHMVNCjPOsbUGdEduuv.jpeg',
          title: 'æ²ä¸½ä¸½ è¯è®ºäºä½ ',
          description: 'æè¿°ä¿¡æ¯æè¿°ä¿¡æ¯æè¿°ä¿¡æ¯',
          datetime: '2017-08-07',
          type: 'æ¶æ¯',
        },
        {
          id: '000000007',
          avatar: 'https://gw.alipayobjects.com/zos/rmsportal/fcHMVNCjPOsbUGdEduuv.jpeg',
          title: 'æ±åå³ åå¤äºä½ ',
          description: 'è¿ç§æ¨¡æ¿ç¨äºæéè°ä¸ä½ åçäºäºå¨ï¼å·¦ä¾§æ¾ãè°ãçå¤´å',
          datetime: '2017-08-07',
          type: 'æ¶æ¯',
        },
        {
          id: '000000008',
          avatar: 'https://gw.alipayobjects.com/zos/rmsportal/fcHMVNCjPOsbUGdEduuv.jpeg',
          title: 'æ é¢',
          description: 'è¿ç§æ¨¡æ¿ç¨äºæéè°ä¸ä½ åçäºäºå¨ï¼å·¦ä¾§æ¾ãè°ãçå¤´å',
          datetime: '2017-08-07',
          type: 'æ¶æ¯',
        },
        {
          id: '000000009',
          title: 'ä»»å¡åç§°',
          description: 'ä»»å¡éè¦å¨ 2017-01-12 20:00 åå¯å¨',
          extra: 'æªå¼å§',
          status: 'todo',
          type: 'å¾å',
        },
        {
          id: '000000010',
          title: 'ç¬¬ä¸æ¹ç´§æ¥ä»£ç åæ´',
          description: 'å éæäº¤äº 2017-01-06ï¼éå¨ 2017-01-07 åå®æä»£ç åæ´ä»»å¡',
          extra: 'é©¬ä¸å°æ',
          status: 'urgent',
          type: 'å¾å',
        },
        {
          id: '000000011',
          title: 'ä¿¡æ¯å®å¨èè¯',
          description: 'ææ´¾ç«¹å°äº 2017-01-09 åå®ææ´æ°å¹¶åå¸',
          extra: 'å·²èæ¶ 8 å¤©',
          status: 'doing',
          type: 'å¾å',
        },
        {
          id: '000000012',
          title: 'ABCD çæ¬åå¸',
          description: 'å éæäº¤äº 2017-01-06ï¼éå¨ 2017-01-07 åå®æä»£ç åæ´ä»»å¡',
          extra: 'è¿è¡ä¸­',
          status: 'processing',
          type: 'å¾å',
        },
      ]);

      this.loading = false;
    }, 1000);
  }

  clear(type: string) {
    this.msg.success(`æ¸ç©ºäº ${type}`);
    this.data.find((w) => w.title === type).list = [];
  }

  select(res: any) {
    this.msg.success(`ç¹å»äº ${res.title} ç ${res.item.title}`);
  }
}
